import { CrisisStreamResponse } from 'types/Crisis/crisis-stream'
import { InferType, object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object({
  participantRole: string().required(),
  eventStreamId: string().required(),
}).required()

export type Request = InferType<typeof Schema>

export type SuccessfulResponse = CrisisStreamResponse

export const url = ({ eventStreamId }: { eventStreamId: string }) =>
  `/v1/crisis-streams/${eventStreamId}/call-participants`

export const getBody = ({ participantRole }: Request) => ({
  participantRole,
})
